<template>
  <div class="w-100">

    <!-- Mobile : ligne 1 — toggle + import + bouton ajout -->
    <div class="d-flex d-md-none align-items-center justify-content-between mb-2">
      <div class="bg-white shadow justify-content-center align-items-center px-1 rounded-2 d-flex">
        <a @click="changeModelViewType(modelViewType.card)"
          :class="(route.query.viewType && route.query.viewType === modelViewType.card) || !route.query.viewType ? 'active' : ''"
          class="btn btn-sm btn-outline-primary text-active-white text-hover-white btn-icon">
          <i class="bi bi-grid-fill fs-4 text-primary"></i>
        </a>
      </div>
      <div class="d-flex align-items-center gap-2">
        <button
          v-if="$can(abilities.CONTACT_IMPORT) || $can(abilities.CONTACT_EXPORT)"
          class="btn btn-sm btn-outline-primary"
          @click="openImportModal"
        >
          <i class="fa fa-file-alt"></i>
        </button>
        <Button btn-class="btn-sm" v-if="$can(abilities.CREATE_CONTACT)" type="new" btn-text="contacts.new_contact" @click="openModalCreateContact"/>
      </div>
    </div>

    <!-- Mobile : ligne 2 — les 2 filtres côte à côte -->
    <div class="d-flex d-md-none align-items-center gap-2 w-100 mb-2">
      <select class="form-select form-select-solid h-40px flex-grow-1" v-model="category">
        <option v-for="option in filterBy" :key="option.value" :value="option.value">
          {{ option.translate }}
        </option>
      </select>
      <select class="form-select form-select-solid h-40px flex-grow-1" v-model="type">
        <option v-for="option in filterByType" :key="option.value" :value="option.value">
          {{ option.translate }}
        </option>
      </select>
    </div>

    <!-- Mobile : ligne 3 — recherche pleine largeur -->
    <div class="d-flex d-md-none w-100" v-if="showSearch">
      <Input
        container-class="w-100"
        inputClass="form-control form-control-sm"
        name="input-search"
        :isInputGroup="true"
        :placeholder="$t('label.search')"
        v-model="model"
      >
        <template #rightAddon>
          <span class="position-absolute border-0 bg-transparent end-0 top-50 translate-middle">
            <i class="fa fa-search"></i>
          </span>
        </template>
      </Input>
    </div>

    <!-- Desktop : ligne unique -->
    <div class="d-none d-md-flex align-items-center gap-2 w-100">
      <div class="bg-white shadow justify-content-center align-items-center px-1 rounded-2 d-flex">
        <a @click="changeModelViewType(modelViewType.card)"
          :class="(route.query.viewType && route.query.viewType === modelViewType.card) || !route.query.viewType ? 'active' : ''"
          class="btn btn-sm btn-outline-primary text-active-white text-hover-white btn-icon me-1">
          <i class="bi bi-grid-fill fs-4 text-primary"></i>
        </a>
        <a @click="changeModelViewType(modelViewType.list)"
          :class="route.query.viewType && route.query.viewType === modelViewType.list ? 'active' : ''"
          class="btn btn-sm btn-outline-primary text-active-white text-hover-white btn-icon">
          <i class="bi bi-list-task fs-4 text-primary"></i>
        </a>
      </div>
      <select class="form-select form-select-solid h-40px" style="width: 200px" v-model="category">
        <option v-for="option in filterBy" :key="option.value" :value="option.value">
          {{ option.translate }}
        </option>
      </select>
      <select class="form-select form-select-solid h-40px" style="width: 200px" v-model="type">
        <option v-for="option in filterByType" :key="option.value" :value="option.value">
          {{ option.translate }}
        </option>
      </select>
      <div class="d-flex align-items-center ms-auto gap-2">
        <Input
          v-if="showSearch"
          container-class=""
          inputClass="form-control form-control-sm"
          name="input-search"
          :isInputGroup="true"
          :placeholder="$t('label.search')"
          v-model="model"
        >
          <template #rightAddon>
            <span class="position-absolute border-0 bg-transparent end-0 top-50 translate-middle">
              <i class="fa fa-search"></i>
            </span>
          </template>
        </Input>
        <OutlineButton btn-class="me-2 btn-sm" icon-class="fa fa-file-alt" type="primary" :border="true" btn-text="exports.text" v-if="$can(abilities.CONTACT_IMPORT) || $can(abilities.CONTACT_EXPORT)" @click="openImportModal"/>
        <Button btn-class="btn-sm" v-if="$can(abilities.CREATE_CONTACT)" type="new" btn-text="contacts.new_contact" @click="openModalCreateContact"/>
      </div>
    </div>

  </div>
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";
import OutlineButton from "@/components/OutlineButton.vue";
import Button from "@/components/Button.vue"
import Input from "@/components/Input.vue";
import {useModelViewType} from "@/composables/modelViewType";
import abilities from "@/composables/abilities";

const { modelViewType } = useModelViewType()
const router = useRouter()
const route = useRoute()

const model = defineModel()
const category = defineModel('category')
const type = defineModel('type')

const props = defineProps({
  title: {required: true, type: String, default: 'breadcrumbs.contact.contacts'},
  breadcrumbs: {required: false, type: Array, default: []},
  back: {required: false, type: Boolean, default: false},
  filterBy: {required: false, type: Array, default: []},
  filterByType: {required: false, type: Array, default: []},
  showSearch: {type: Boolean, default: true}
})

function openImportModal() {
  $('#importContactModal').modal('toggle')
}
function openModalCreateContact() {
  $('#contactCreateModal').modal('toggle')
}

function changeModelViewType (viewType) {
  router.push({ query: { viewType } });
}
</script>

